

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { SVGPathData, encodeSVGPath } from 'svg-pathdata';

import * as def from '@/definitions'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { Vector2 } from '@/utilityModels/vector2';
import { Rectangle } from '@/utilityModels/rectangle';

import TrimHandleTopLeft from './resources/trimHandleTopLeft.vue';
import TrimHandleBottomLeft from './resources/trimHandleBottomLeft.vue';
import TrimHandleBottomRight from './resources/trimHandleBottomRight.vue';
import TrimHandleTopRight from './resources/trimHandleTopRight.vue';
import TrimHandleLeft from './resources/trimHandleLeft.vue';
import TrimHandleTop from './resources/trimHandleTop.vue';
import TrimHandleRight from './resources/trimHandleRight.vue';
import TrimHandleBottom from './resources/trimHandleBottom.vue';

@Component({
    components: {
        TrimHandleTopLeft,
        TrimHandleBottomLeft,
        TrimHandleBottomRight,
        TrimHandleTopRight,
        TrimHandleLeft,
        TrimHandleTop,
        TrimHandleRight,
        TrimHandleBottom
    },
})

// トリミングコントローラ
export default class TrimBox extends Vue 
{
    @Prop() private layer! : Layer | null;
    @Prop() private scale! : number;
    @Prop() private offsetX! : number;
    @Prop() private offsetY! : number;
    @Prop() private cursorWidth! : number;
    @Prop() private cursorHeight! : number;

    private get x1() : number { return this.trimMaskRect.x; }
    private get y1() : number { return this.trimMaskRect.y; }
    private get x2() : number { return this.trimMaskRect.x; }
    private get y2() : number { return this.trimMaskRect.bottom; }
    private get x3() : number { return this.trimMaskRect.right; }
    private get y3() : number { return this.trimMaskRect.bottom; }
    private get x4() : number { return this.trimMaskRect.right; }
    private get y4() : number { return this.trimMaskRect.y; }

    private get lx() : number { return (this.x1 + this.x2) / 2; }
    private get ly() : number { return (this.y1 + this.y2) / 2; }
    private get tx() : number { return (this.x1 + this.x4) / 2; }
    private get ty() : number { return (this.y1 + this.y4) / 2; }
    private get rx() : number { return (this.x3 + this.x4) / 2; }
    private get ry() : number { return (this.y3 + this.y4) / 2; }
    private get bx() : number { return (this.x2 + this.x3) / 2; }
    private get by() : number { return (this.y2 + this.y3) / 2; }

    private get baseRect()
    {
        if(this.layer == null) { return new Rectangle(); }
        var x = this.layer.x * this.scale + this.offsetX;
        var y = this.layer.y * this.scale + this.offsetY;
        var width = this.layer.width * this.scale;
        var height = this.layer.height * this.scale;

        return new Rectangle(x, y, width, height);
    }

    private get trimMaskRect()
    {
        if(this.layer == null || !(this.layer instanceof ImageLayer)) { return new Rectangle(); }
        var x = this.baseRect.x + this.baseRect.width * this.layer.trimRectNormalized.x / 100;
        var y = this.baseRect.y + this.baseRect.height * this.layer.trimRectNormalized.y / 100;
        var w = this.baseRect.width * this.layer.trimRectNormalized.width / 100;
        var h = this.baseRect.height * this.layer.trimRectNormalized.height / 100;
        return new Rectangle(x, y, w, h);
    }

    private get isClip()
    {
        if(this.layer == null || !(this.layer instanceof ImageLayer)) { return false; }
        return this.layer.isClip;
    }

    private get clipPath()
    {
        if(this.layer == null || !(this.layer instanceof ImageLayer)) { return false; }
        return this.layer.clipShapeSvgPath;
    }

    private get clipPathTransform()
    {
        var transform = "";

        // 移動
        transform += "translate(" + this.trimMaskRect.x + " " + this.trimMaskRect.y + "),";

        // 100 -> 領域に拡大する
        var scaleX = this.trimMaskRect.width / 100;
        var scaleY = this.trimMaskRect.height / 100;
        transform += "scale(" + scaleX + " " + scaleY + ")";
        
        return transform;
    }

    private get baseTransform()
    {
        if(this.layer == null) { return ""; }

        var transform = "";

        transform += "translate(" + this.baseRect.x + " " + this.baseRect.y + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        transform += "translate(" + (-this.baseRect.x) + " " + (-this.baseRect.y) + ")";
        
        return transform;
    }

    private selectCursor2(event : MouseEvent, cursor : string)
    {
        // カーソル選択イベント通知
        this.$emit("cursorSelected", cursor);
    }

    private selectCursor(cursor : string)
    {
        // カーソル選択イベント通知
        this.$emit("cursorSelected", cursor);
    }
}
